import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Dropdown.styles';
const Dropdown = ({ name, label, onChange, options, activeOption }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    return (React.createElement(S.Container, { "data-is-open": isOpen },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Select, { onChange: (e) => onChange(e), "aria-label": label, name: name, onClick: () => setIsOpen(!isOpen), value: activeOption },
                React.createElement("option", { value: "" }, label),
                options.map((o) => (React.createElement("option", { key: `option-${name}-${o.value}`, value: o.value }, o.label)))))));
};
export default Dropdown;
